// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__eIg24","itemTitle":"ClientEmergencyInfo_itemTitle__3Muu2","itemText":"ClientEmergencyInfo_itemText__1rZvN"};